import { useKeyboardShortcut } from "./useKeyboardShortcut";

type NavigationDirection = "left" | "right";

/**
 * Custom hook to add keyboard shortcuts for page navigation
 * - Command/Ctrl + Right Arrow for forward navigation
 * - Command/Ctrl + Left Arrow for backward navigation
 *
 * This is a convenience wrapper around useKeyboardShortcut
 */
export function usePageNavigationShortcut(
    direction: NavigationDirection,
    handler: () => void,
    disabled: boolean = false
) {
    useKeyboardShortcut({
        key: direction === "left" ? "ArrowLeft" : "ArrowRight",
        handler,
        disabled,
        requireMeta: true // Handles both Command (Mac) and Ctrl (Windows)
    });
}
